(function () {
  'use strict';
  if (window.HushCartExperience) return;
  var busy = false, blocked = false, accepted = false, activeQuote = null, nativeForm = null;
  var queued = false, lastState = '', lastOpen = false, slowTimer = null;
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  var statusCopy = '', statusError = false;
  var disableStates = new Map();
  function drawer() { return document.querySelector('cart-drawer[data-hush-cart-drawer]'); }
  function consume(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function hasDirtyQuantities() {
    return Array.prototype.some.call(document.querySelectorAll('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]'), function (input) {
      return input.value !== input.getAttribute('value');
    });
  }
  function nativePending() {
    return typeof CartItems !== 'undefined' && CartItems.pendingUpdates > 0 ||
      Boolean(document.querySelector('.cart__items--disabled')) || hasDirtyQuantities();
  }
  function pending() { return busy || blocked || nativePending() || Boolean(window.HushCheckoutHandoff && window.HushCheckoutHandoff.isPending()); }
  function showStatus(copy, error) {
    statusCopy = copy || ''; statusError = Boolean(error);
    var element = document.querySelector('[data-hush-cart-status]');
    if (!element) return;
    element.textContent = statusCopy;
    element.hidden = !statusCopy;
    element.setAttribute('role', error ? 'alert' : 'status');
    if (error) {
      var link = document.createElement('a');
      link.href = root + 'cart'; link.className = 'underlined-link'; link.textContent = 'View cart to check your order';
      element.appendChild(document.createTextNode(' ')); element.appendChild(link);
    }
  }
  function controls() {
    if (busy || blocked) {
      document.querySelectorAll('[data-hush-upgrade-button], [data-hush-discount-form] button, .cart-item button, .cart-item input').forEach(function (element) {
        if (!disableStates.has(element)) disableStates.set(element, element.disabled);
        element.disabled = true;
      });
    } else {
      disableStates.forEach(function (value, element) { if (element.isConnected) element.disabled = value; });
      disableStates.clear();
    }
    var checkout = document.getElementById('CartDrawer-Checkout');
    if (checkout) {
      var empty = drawer() && drawer().classList.contains('is-empty');
      checkout.disabled = Boolean(empty || busy || blocked || nativePending());
      checkout.classList.toggle('loading', busy && window.HushCheckoutHandoff && window.HushCheckoutHandoff.isPending());
    }
  }
  function setBusy(value) {
    if (busy === value) return;
    busy = value;
    if (typeof CartItems !== 'undefined') CartItems.syncCheckoutState(value ? 1 : -1);
    controls();
  }
  function stateFromDOM() {
    var element = document.querySelector('[data-hush-cart-state]');
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (_) { return null; }
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function paint() {
    queued = false;
    var host = drawer();
    if (!host) return;
    var open = host.classList.contains('active');
    if (open && !lastOpen && !busy) accepted = false;
    lastOpen = open;
    var element = host.querySelector('[data-hush-cart-state]');
    var raw = element && element.textContent || '';
    if (lastState !== raw) { lastState = raw; activeQuote = null; }
    var cart = stateFromDOM();
    var card = host.querySelector('[data-hush-upgrade]');
    activeQuote = !accepted && !blocked && window.HushCartUpgrade && window.HushCartUpgrade.quote(cart);
    if (card) {
      card.hidden = !activeQuote;
      if (activeQuote) {
        card.querySelector('[data-hush-upgrade-title]').textContent = 'Get ' + activeQuote.increment + ' more tins for ' + money(activeQuote.delta).replace(/\.00$/, '');
        var flavors = [];
        if (activeQuote.flavorincrements.mint) flavors.push(activeQuote.flavorincrements.mint + ' Mint');
        if (activeQuote.flavorincrements.vanilla) flavors.push(activeQuote.flavorincrements.vanilla + ' Vanilla');
        card.querySelector('[data-hush-upgrade-copy]').textContent = 'Adds ' + flavors.join(' + ') + ' · ' + money(activeQuote.total) + ' subtotal' + (activeQuote.total >= 7000 ? ' · Free standard U.S. shipping' : '');
        card.querySelector('[data-hush-upgrade-price]').textContent = 'Just ' + money(activeQuote.delta / activeQuote.increment) + ' per extra tin';
        var button = card.querySelector('[data-hush-upgrade-button]');
        button.textContent = 'Upgrade to ' + activeQuote.to + ' tins';
        button.setAttribute('aria-label', 'Upgrade to ' + activeQuote.to + ' tins for ' + money(activeQuote.delta) + ' more. New subtotal ' + money(activeQuote.total) + '.');
      }
    }
    if (statusCopy) showStatus(statusCopy, statusError);
    controls();
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(paint); } }
  function request(path, body) {
    var options = { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (body) { options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    var timer;
    // Do not replay or abort a mutation with an unknown server outcome.
    var operation = window.fetch(root + path, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || !data || data.status >= 400 || data.errors) {
          var error = new Error(data && (data.description || data.message) || 'We couldn’t update your cart.');
          error.confirmed = response.status === 422; throw error;
        }
        return data;
      });
    });
    return Promise.race([operation, new Promise(function (_, reject) {
      timer = window.setTimeout(function () { reject(new Error('This update is taking longer than expected.')); }, 30000);
    })]).finally(function () { window.clearTimeout(timer); });
  }
  function readCart() { return request('cart.js'); }
  function sectionNames() {
    var names = ['cart-drawer', 'cart-icon-bubble'];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var element = document.getElementById(id);
      if (element && element.dataset.id) names.push(element.dataset.id);
    });
    return names;
  }
  function sectionBody() { return { sections: sectionNames(), sections_url: window.location.pathname }; }
  function renderSections(sections) {
    if (!sections || !sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error('We couldn’t refresh your cart.');
    var host = drawer();
    if (!host || typeof host.renderContents !== 'function') throw new Error('Please open your cart again.');
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var state = doc.querySelector('[data-hush-cart-state]');
    if (!state) throw new Error('We couldn’t confirm your cart.');
    var cart = JSON.parse(state.textContent);
    host.classList.toggle('is-empty', !cart.item_count);
    host.renderContents({ sections: sections });
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var element = document.getElementById(id);
      if (!element) return;
      if (!sections[element.dataset.id]) throw new Error('Please refresh your cart to confirm the total.');
      var parsed = new DOMParser().parseFromString(sections[element.dataset.id], 'text/html');
      var content = parsed.querySelector('.js-contents');
      var target = element.querySelector('.js-contents');
      if (!content || !target) throw new Error('Please refresh your cart to confirm the total.');
      target.innerHTML = content.innerHTML;
      element.classList.toggle('is-empty', !cart.item_count);
    });
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
    schedule();
    return cart;
  }
  function refresh() {
    return request('?sections=' + sectionNames().join(',')).then(renderSections);
  }
  async function upgrade() {
    if (pending() || !activeQuote) { showStatus('Please wait for your cart to finish updating.'); return; }
    var quote = activeQuote;
    setBusy(true); showStatus('Checking your pack…');
    var mutationStarted = false;
    try {
      var before = await readCart();
      var additions = window.HushCartUpgrade.additions(before, quote);
      if (!additions) { await refresh(); showStatus('Your cart changed. Please review the updated offer.'); return; }
      showStatus('Adding your extra tins…');
      var result, after = before;
      // Change the existing lines so the product-page bundle app cannot replace
      // an add request with the currently selected pack. Recheck each response:
      // a new bundle discount can change line keys between the two updates.
      for (var index = 0; index < additions.length; index += 1) {
        var change = window.HushCartUpgrade.nextChange(before, after, quote, index);
        if (!change) throw new Error('Your cart changed during the upgrade.');
        mutationStarted = true;
        result = await request('cart/change.js', Object.assign(change, sectionBody()));
        after = await readCart();
      }
      accepted = true;
      renderSections(result.sections);
      if (!window.HushCartUpgrade.verify(before, after, quote)) {
        await refresh();
        showStatus('Your cart has been updated. Please review the quantities and current subtotal before checkout.', true);
      } else showStatus('Added. Your ' + quote.to + '-tin subtotal is ' + money(after.total_price) + '.');
    } catch (error) {
      if (mutationStarted) {
        accepted = true;
        blocked = true;
        if (error.confirmed) {
          try { await refresh(); blocked = false; } catch (_) { /* Keep recovery required. */ }
        }
      }
      showStatus(error.confirmed ? error.message : 'We couldn’t confirm this update. Check your cart before trying again.', true);
    } finally { setBusy(false); paint(); }
  }
  function discountCodes(cart) {
    var codes = [];
    (cart.discount_codes || []).forEach(function (discount) { if (discount.code && discount.applicable !== false) codes.push(discount.code); });
    var applications = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || item.discount_allocations || []).forEach(function (allocation) { if (allocation.discount_application) applications.push(allocation.discount_application); });
    });
    applications.forEach(function (application) { if (application.type === 'discount_code' && application.title) codes.push(application.title); });
    return codes.filter(function (code, index) { return codes.findIndex(function (candidate) { return candidate.toLowerCase() === code.toLowerCase(); }) === index; });
  }
  function discountStatus(copy) {
    var details = document.querySelector('.hush-cart-discount');
    if (details) details.open = true;
    var element = document.querySelector('[data-hush-discount-status]');
    if (element) { element.hidden = false; element.textContent = copy; }
  }
  async function applyDiscount(form) {
    if (pending()) { showStatus('Please wait for your cart to finish updating.'); return; }
    var input = form.querySelector('[name="discount"]');
    var code = input.value.trim();
    if (!code || code.length > 255 || code.indexOf(',') !== -1) { discountStatus('Enter one discount code at a time.'); return; }
    setBusy(true); showStatus('Checking your discount…');
    var started = false;
    try {
      var before = await readCart();
      var codes = discountCodes(before);
      if (!codes.some(function (existing) { return existing.toLowerCase() === code.toLowerCase(); })) codes.push(code);
      started = true;
      var result = await request('cart/update.js', Object.assign({ discount: codes.join(',') }, sectionBody()));
      renderSections(result.sections);
      var explicit = (result.discount_codes || []).find(function (discount) { return String(discount.code).toLowerCase() === code.toLowerCase(); });
      var applied = discountCodes(result).some(function (existing) { return existing.toLowerCase() === code.toLowerCase(); });
      if (explicit && explicit.applicable === false) discountStatus('This code isn’t available for the items in your cart.');
      else if (explicit && explicit.applicable === true || !explicit && applied) discountStatus('Code applied. Your current subtotal is shown below.');
      else discountStatus('No savings confirmed for this code. Check the code or try it at checkout.');
      showStatus('');
      document.dispatchEvent(new CustomEvent('hush:cart-discount-updated'));
    } catch (_) {
      if (started) blocked = true;
      showStatus('We couldn’t confirm the discount update. Please check your cart.', true);
    } finally { setBusy(false); paint(); }
  }
  async function checkout() {
    if (pending()) { showStatus(blocked ? 'Please check your cart before continuing.' : 'Please wait for your cart to finish updating.', blocked); return; }
    if (!window.HushCheckoutHandoff) { showStatus('Checkout is still loading. Please try again in a moment.'); return; }
    setBusy(true); showStatus('Opening secure checkout…');
    try { await window.HushCheckoutHandoff.start(); }
    catch (error) { showStatus(error.message || 'We couldn’t open checkout. Please try again.', true); setBusy(false); }
  }
  function beginAdd(form) {
    if (!drawer()) return true;
    if (pending()) {
      if (form.handleErrorMessage) form.handleErrorMessage(blocked ? 'Please view your cart to check the last add before trying again.' : 'Your cart is updating. Please wait a moment.');
      return false;
    }
    nativeForm = form; setBusy(true); showStatus('');
    slowTimer = window.setTimeout(function () {
      if (nativeForm === form && form.handleErrorMessage) form.handleErrorMessage('This add is taking longer than expected. Please wait, or view your cart before adding again.');
    }, 10000);
    return true;
  }
  function added(form) {
    if (form !== nativeForm) return;
    window.clearTimeout(slowTimer); nativeForm = null; accepted = false; blocked = false;
    showStatus(''); setBusy(false);
  }
  async function failed(form, message, uncertain) {
    if (form !== nativeForm) return;
    window.clearTimeout(slowTimer); nativeForm = null;
    blocked = true;
    var copy = uncertain ? 'We couldn’t confirm whether your pack was added. View your cart before trying again.' : message;
    if (form.handleErrorMessage) form.handleErrorMessage(copy);
    showStatus(copy, true);
    // A native inventory rejection can leave a partial quantity in the cart.
    // Show the real result before allowing another add; never repeat the POST.
    if (!uncertain) {
      try { await refresh(); blocked = false; } catch (_) { /* Require explicit recovery. */ }
    }
    setBusy(false);
    if (uncertain && drawer()) drawer().open();
  }
  // Capture before Patrol's document handler, preserving its lock/release path
  // exclusively through HushCheckoutHandoff rather than competing redirects.
  window.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    if (target.closest('[name="checkout"]') && drawer()) { consume(event); checkout(); return; }
    if (target.closest('[data-hush-upgrade-button]')) { consume(event); upgrade(); return; }
    if ((busy || blocked) && target.closest('.cart-item button, .cart-item input, product-form [type="submit"]')) { consume(event); showStatus('Please wait, or check your cart before making another change.', blocked); }
  }, true);
  window.addEventListener('submit', function (event) {
    if (event.target.matches('[data-hush-discount-form]')) { consume(event); applyDiscount(event.target); return; }
    if (event.target.id === 'CartDrawer-Form' || event.submitter && event.submitter.name === 'checkout') { consume(event); checkout(); }
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target.matches('.cart-item input[name="updates[]"]')) schedule();
  });
  function start() {
    var host = drawer(); if (!host) return;
    new MutationObserver(function (records) {
      if (records.every(function (record) {
        return record.target.nodeType === 1 && record.target.closest('[data-hush-upgrade], [data-hush-cart-status], .hush-cart-discount, [data-hush-reservation-placement]');
      })) return;
      schedule();
    }).observe(host, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    paint();
  }
  window.HushCartExperience = { beginAdd: beginAdd, added: added, failed: failed, isPending: pending, refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
